export default __webpack_public_path__ + "static/media/malt-syrup-thumb.3c4c5c07.jpg";